// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2HZ8I","inputWrap":"Table_inputWrap__Zpv_8","col":"Table_col__3s3RQ","bmiTooltip":"Table_bmiTooltip__jMQR-"};